import React from 'react';
import { X, Share, Plus, Home, ArrowDown } from 'lucide-react';

const PWAInstallInstructions = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-lg max-w-sm w-full max-h-[80vh] overflow-y-auto">
        <div className="p-4 border-b">
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-bold">Install FlowFrame</h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
        
        <div className="p-4">
          <p className="text-sm text-gray-600 mb-4">
            Install FlowFrame as an app on your device for offline access and a better experience:
          </p>
          
          <div className="space-y-4">
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center text-xs font-bold">
                1
              </div>
              <div className="flex-1">
                <p className="text-sm font-medium">Tap the Share button</p>
                <div className="flex items-center mt-1">
                  <Share className="w-4 h-4 text-blue-500 mr-1" />
                  <span className="text-xs text-gray-500">Usually at the bottom of Safari</span>
                </div>
              </div>
            </div>
            
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center text-xs font-bold">
                2
              </div>
              <div className="flex-1">
                <p className="text-sm font-medium">Scroll down and tap "Add to Home Screen"</p>
                <div className="flex items-center mt-1">
                  <Plus className="w-4 h-4 text-green-500 mr-1" />
                  <Home className="w-4 h-4 text-green-500 mr-1" />
                  <span className="text-xs text-gray-500">Look for this icon combo</span>
                </div>
              </div>
            </div>
            
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center text-xs font-bold">
                3
              </div>
              <div className="flex-1">
                <p className="text-sm font-medium">Tap "Add" to confirm</p>
                <p className="text-xs text-gray-500 mt-1">
                  FlowFrame will appear on your home screen like a native app!
                </p>
              </div>
            </div>
          </div>
          
          <div className="mt-6 p-3 bg-blue-50 rounded-lg">
            <p className="text-xs text-blue-700">
              <strong>Benefits:</strong> Faster loading, offline access, no browser bars, and notifications support.
            </p>
          </div>
          
          <button
            onClick={onClose}
            className="w-full mt-4 bg-accent-600 text-white py-2 rounded font-medium hover:bg-accent-500 transition-colors"
          >
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
};

export default PWAInstallInstructions;